var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 600 600",
    style: {
      enableBackground: "new 0 0 600 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, ".st0{fill:gray}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g26",
    transform: "translate(-142.986 -207.414) scale(1.6814)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M356.14 404.42c-.33 5.39-.02 10.34-1.07 14.98-1.75 7.78-9.42 13.17-17.74 13.22-11.27.07-22.54.03-33.81.03-39.31 0-78.62 0-117.94-.01-9.23 0-16.25-4.87-18.78-13.37-.76-2.54-.86-5.34-.87-8.02-.01-9.36.25-18.72.24-28.08-.04-27.31-.22-54.63-.26-81.94-.05-34.78.02-69.56-.04-104.34-.01-7.08 1.89-13.13 7.89-17.43 3.1-2.22 6.48-3.51 10.31-3.52 7.48-.01 14.97.06 22.45-.05 2.18-.03 2.82.76 2.76 2.84-.12 3.78-.05 7.57-.03 11.36.04 8.35 3.11 15.42 9.03 21.28.57.57 1.14 1.15 1.68 1.75.08.09.01.33.01.87h-32.86c-7.23 0-9.8 2.55-9.8 9.7v187.69c0 7.08 2.56 9.67 9.57 9.67h147.15c1.7 0 3.49.23 5.09-.21 3.67-1 5.32-3.53 5.47-7.69.19-5.19.19-5.2 5-6.74 1.91-.6 3.8-1.15 6.55-1.99z",
    id: "path4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M368.36 390.14c-31.2 22.51-71.05 13.1-90.72-13.24-18.75-25.13-17.25-60.66 4.69-83.6 23.04-24.1 58.88-27.27 85.61-8.03 25.9 18.64 37.18 59.21 13.79 91.68 2.19 2.05 4.34 4.19 6.62 6.2 13.35 11.8 26.75 23.55 40.1 35.35 4.16 3.67 5.22 8.4 3.7 13.54-1.54 5.23-5.38 8.21-10.74 9-4.4.65-8.32-.73-11.24-4.01-12.67-14.29-25.2-28.69-37.82-43.02-1.18-1.35-2.57-2.51-3.99-3.87zm-92.88-52.41c-.44 29.45 24.06 54.34 53.95 54.27 30.01-.07 54.28-24.12 54.29-54 .01-30.24-23.94-54.26-54.13-54.28-30.14-.02-54.1 23.89-54.11 54.01zm108.25 46.62c-.46.4-1.16.75-1.13 1.03.07.61.37 1.33.82 1.73 11.43 10.27 22.88 20.52 34.34 30.76 1.07.96 2.12 1.96 3.28 2.8.48.35 1.24.31 1.87.45-.16-.6-.26-1.23-.51-1.8-.13-.3-.51-.49-.78-.73-11.59-10.63-23.17-21.27-34.78-31.88-.91-.84-1.98-1.51-3.11-2.36z",
    id: "path6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M260.99 158.19c12.8 0 25.6-.01 38.4 0 5.39 0 7.47 1.97 7.47 7.25 0 8.83.34 17.69-.25 26.49-.85 12.8-10.61 21.75-23.43 21.9-14.78.17-29.57.18-44.35 0-13.5-.16-23.38-10.14-23.67-23.76-.18-8.38-.08-16.77-.02-25.15.04-4.59 2.27-6.72 6.9-6.72 12.98-.02 25.96-.01 38.95-.01zm.11 35.22c4.37-.05 7.71-3.45 7.62-7.77-.08-4.15-3.78-7.81-7.81-7.74-4.09.07-7.63 3.77-7.6 7.94.03 4.37 3.37 7.62 7.79 7.57z",
    id: "path8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M355.88 271.08c-3.58-1.02-6.72-1.81-9.77-2.87-.65-.23-1.4-1.39-1.4-2.12-.06-11.81-.01-23.62.01-35.43.01-3.06.15-6.13 0-9.18-.23-4.44-3.5-7.45-8-7.47-10.64-.04-21.28-.01-31.92-.02-.94 0-1.89-.08-2.83-.12-.3-.4-.61-.8-.91-1.2.83-.38 1.83-.57 2.45-1.16 6.16-5.92 9.25-13.17 9.23-21.73-.01-3.88.04-7.75-.02-11.63-.03-1.63.61-2.24 2.23-2.23 8.02.06 16.06-.17 24.07.12 8.54.31 16.23 7.8 16.72 16.3.35 6.19.03 12.42.08 18.63.04 4.93.23 9.86.25 14.79.04 14.06.02 28.13.01 42.19-.01.96-.13 1.93-.2 3.13z",
    id: "path10"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M288.59 240.89c12.08 0 24.15.05 36.23-.05 2.22-.02 3.09.61 2.91 2.88-.17 2.15-.11 4.33-.02 6.48.08 1.77-.67 2.36-2.39 2.34-5.95-.06-11.89-.02-17.84-.02-18.38 0-36.77-.05-55.15.06-2.62.01-3.57-.77-3.31-3.36.19-1.87.16-3.79.01-5.67-.18-2.2.74-2.72 2.8-2.71 12.25.09 24.51.05 36.76.05z",
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.57 392.1c-1.09.1-1.86.24-2.62.24-9.26.01-18.52-.07-27.77.05-2.51.03-3.37-.81-3.15-3.26.18-2.05.09-4.13.02-6.2-.05-1.56.46-2.32 2.14-2.31 6.56.05 13.12 0 19.68.04.67 0 1.57.15 1.97.58 3.2 3.48 6.32 7.03 9.73 10.86z",
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M278.4 287.51c-3.08 3.98-5.71 7.48-8.48 10.87-.41.5-1.44.69-2.18.69-5.49.03-10.98-.06-16.47-.03-1.62.01-2.29-.55-2.23-2.19.08-2.43-.09-4.88.09-7.3.05-.71.93-1.95 1.44-1.96 9.08-.12 18.17-.08 27.83-.08z",
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M258.27 345.74c-2.6 0-5.02.12-7.42-.08-.64-.05-1.66-1.08-1.7-1.72-.19-2.69-.07-5.4-.09-8.1-.01-2.2 1.69-1.98 2.87-1.71 2.11.48 5.4-1.76 6.18 1.54.73 3.05.16 6.41.16 10.07z",
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M330.57 295.67c13.33.88 24.14 6.47 32.21 17.19 1.71 2.27 1.48 4.54-.45 5.93-1.92 1.37-3.99.89-5.8-1.45-6.91-8.97-16.04-13.61-27.34-14.02-2.53-.09-4.09-1.51-4.15-3.67-.06-2.3 1.54-3.82 4.17-3.96.46-.04.91-.02 1.36-.02z",
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M370.74 333.36c-.14 2.51-1.22 3.97-3.34 4.34-2.19.38-3.69-.82-4.24-2.86-.51-1.89-.83-3.88-.88-5.83-.04-1.84.96-3.3 2.93-3.66 2.14-.39 3.8.47 4.43 2.55.58 1.88.79 3.86 1.1 5.46z",
    id: "path22"
  })))), /*#__PURE__*/React.createElement("circle", {
    cx: 215.437,
    cy: 358.477,
    r: 25.944,
    id: "circle28",
    style: {
      strokeWidth: 1.6814,
      fill: "#65ab65"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.437,
    cy: 436.309,
    r: 25.944,
    id: "circle30",
    style: {
      strokeWidth: 1.6814,
      fill: "#de7c73"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.437,
    cy: 280.662,
    r: 25.944,
    id: "circle32",
    style: {
      strokeWidth: 1.6814,
      fill: "#48b2d2"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.437,
    cy: 202.847,
    r: 25.944,
    id: "circle34",
    style: {
      strokeWidth: 1.6814,
      fill: "#e79933"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResources);
export default __webpack_public_path__ + "static/media/resources.59a2b3f9a7c722f18b1213f62fd044ec.svg";
export { ForwardRef as ReactComponent };